import { Optional, Record, String, Unknown } from 'runtypes'

export const FilterFieldsTypeGuard = Record({
  uuid_objectclass: String,
  uuid_classification: Optional(String),
  filter_area_layout: Optional(Record({})),
  defaultExecutedFilteraction: Optional(String),
  styleMap: Optional(Unknown)
})
